import React, { useCallback, useState } from 'react'

import { graphql } from 'gatsby'

import Img from '../components/Img'
import PriceCard from '../components/PriceCard'
import RadioGroup from '../components/RadioGroup'

import { transformDataForFiltersRichText } from '../utils/transformDataForFilters'

const PricingSection = ({ slice }) => {
  const { primary, items } = slice

  const [value, setValue] = useState(null)

  const getValue = useCallback((val) => setValue(val))

  return (
    <section className={`section pricing-section`}>
      {primary?.background_image?.gatsbyImageData && (
        <Img
          image={primary.background_image.gatsbyImageData}
          alt={primary?.background_image?.alt}
          className="background-image background-image-one"
        />
      )}
      <div className="container">
        <h1 className="title">{primary?.title1?.text}</h1>
        <RadioGroup
          items={transformDataForFiltersRichText(primary?.price_plan)}
          getValue={getValue}
        />
        <div className="pricing-section-list">
          {items?.map((item) => {
            const price = item?.price_link?.document?.data
            return <PriceCard price={price} pricePlan={value} key={item} />
          })}
        </div>
      </div>
      {primary?.background_image_two?.gatsbyImageData && (
        <Img
          image={primary.background_image_two.gatsbyImageData}
          alt={primary?.background_image_two?.alt}
          className="background-image background-image-two"
        />
      )}
    </section>
  )
}

export default PricingSection

export const query = graphql`
  fragment PricePageDataBodyPriceSection on PrismicPricePageDataBodyPriceSection {
    id
    items {
      price_link {
        document {
          ... on PrismicPrice {
            id
            data {
              button_theme
              button_title {
                text
              }
              included {
                included_text
                included1
              }
              included_title
              per_month_text
              price_per_month
              price_per_month_monthly
              title
              button_link {
                url
                target
              }
            }
          }
        }
      }
    }
    primary {
      background_image {
        gatsbyImageData
        alt
      }
      background_image_two {
        gatsbyImageData
        alt
      }
      price_plan {
        richText
      }
      title1 {
        text
      }
    }
  }
`
